import Hotjar from '@hotjar/browser';

const siteId = "3715975";
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);